import {useLocale} from "../../hooks/use-locale";
import {FC} from "react";
import {Box} from "@mui/material";

interface YouTubeProps {
    id: string;
    title?: string;
}

export function Youtube({id, title}: YouTubeProps) {
    const locale = useLocale()

    return <div>
        <Box sx={{
            position: "relative",
            paddingBottom: "56.25%"
        }}>

            <iframe
                src={`//www.youtube-nocookie.com/embed/${id}?rel=0&modestbranding=1&cc_load_policy=1&hl=${locale}`}
                style={{
                    position: "absolute",
                    border: 0,
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                }}
                allowFullScreen
                title={title || "YouTube Video"}></iframe>
        </Box>
    </div>
}
